export default "__VITE_ASSET__2046032a__"